import { render, staticRenderFns } from "./editRoleManage.vue?vue&type=template&id=40b28d7a&scoped=true"
import script from "./editRoleManage.vue?vue&type=script&lang=js"
export * from "./editRoleManage.vue?vue&type=script&lang=js"
import style0 from "./editRoleManage.vue?vue&type=style&index=0&id=40b28d7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b28d7a",
  null
  
)

export default component.exports